import * as React from "react";
import type { SVGProps } from "react";
const SvgBarChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 21.6v-2.133M8.8 21.6v-7.467m6.4 7.467V8.8m6.4 12.8V2.4"
    />
  </svg>
);
export default SvgBarChart03;
